import React from 'react'

import { theme } from '@acorns/web-components'
import { AnimatePresence, motion } from 'framer-motion'
import styled from 'styled-components'

import { publishingColors } from '../../../../styles'
import { AgeOfTransferIndicator } from './AgeOfTransferIndicator'

const TotalBalanceBar = styled(motion.div)<{ width: number }>`
  align-self: flex-end;
  background-color: ${theme.colors.bark};
  border-radius: 5px;
  box-sizing: border-box;
  display: flex;
  position: relative;
  text-align: center;
  width: ${(props) => props.width}px;
`

const InvestmentTotalBar = styled(motion.div)<{ percent: number }>`
  align-self: flex-end;
  background-color: ${publishingColors.tan};
  border-radius: 5px;
  height: calc(100% * ${(props) => props.percent});
  margin: 0 auto;
  max-height: 100%;
  transition: height 0.4s;
  width: 100%;
`

const resizeVariants = (index: number, hasDelay: boolean) => ({
  delay: {
    damping: hasDelay ? 12 : 15,
    delay: hasDelay ? 0.01 * index : 0,
    duration: 0.4,
    stiffness: hasDelay ? 100 : 300,
    type: 'spring',
  },
  noDelay: {
    duration: 0.2,
    ease: 'easeInOut',
  },
})

export const Bar: React.FC<{
  barHeight: number
  barWidth: number
  hasDelay: boolean
  index: number
  investedPercentage: number
  isAgeOfTransfer?: boolean
  onStopDelay: (hasDelay: boolean) => void
}> = ({
  barHeight,
  barWidth,
  hasDelay,
  index,
  investedPercentage,
  isAgeOfTransfer,
  onStopDelay,
}) => {
  return (
    <TotalBalanceBar
      initial={{ height: 0 }}
      animate={{
        height: barHeight > barWidth ? barHeight : barWidth,
      }}
      transition={
        hasDelay
          ? resizeVariants(index, hasDelay).delay
          : resizeVariants(index, hasDelay).noDelay
      }
      onAnimationComplete={() => {
        if (index === 30) {
          onStopDelay(false)
        }
      }}
      width={barWidth}
    >
      <AnimatePresence>
        {isAgeOfTransfer && <AgeOfTransferIndicator width={barWidth} />}
      </AnimatePresence>
      <InvestmentTotalBar percent={investedPercentage} />
    </TotalBalanceBar>
  )
}
